<template>
  <v-card
      :height="isChild?175:330"
      class="rounded-lg white"
  >
    <v-card-title v-if="showTitle" class="mr-3 mt-3 secondary--text">
      <v-img class="ml-3" src="/img/icons/bell-circle.svg" max-width="25" max-height="25"></v-img>
      آخرین اعلان های <span class="info--text mr-2">دریافتی</span>
      <v-spacer></v-spacer>
      <v-tooltip right >
        <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" fab icon class="mr-3" href="notificationsList">
        <v-img class="" src="/img/icons/info_circle.svg" max-width="23"></v-img>
      </v-btn>
        </template>
        مشاهده کامل
      </v-tooltip>
    </v-card-title>
    <v-simple-table :class="isChild?'rounded-b-lg':'mr-2 ml-2 rounded-b-lg'">
      <template v-slot:default>
        <thead>
        <tr :class="isChild?'secondary':''">
          <th :class="isChild?'white--text text-center':'text-center'">
            عنوان
          </th>
          <th :class="isChild?'white--text text-center':'text-center'">
            توضیحات
          </th>
          <th :class="isChild?'white--text text-center':'text-center'">
            تاریخ و ساعت
          </th>
          <th :class="isChild?'white--text text-center':'text-center'">
            وضعیت
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="notification in notifications">
          <td class="text-center">{{notification.title}}</td>
          <td class="text-center">{{notification.explanation}}</td>
          <td class="text-center">{{notification.created_at}}</td>
          <td class="text-center" v-if="notification.status == 'خوانده نشده'">
            <v-tooltip right color="success">
              <template v-slot:activator="{ on, attrs }">
              <v-btn icon class="rounded-lg" v-bind="attrs" v-on="on" @click="changeStatus(notification, 'r')">
              <v-icon class="success--text">fa-check-double</v-icon>
              </v-btn>
              </template>
              علامت به عنوان خوانده شده
            </v-tooltip>
          </td>
          <td v-else class="text-center info--text">
            خوانده شده
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
export default {
  name: "ReceivedNotifications",
  components: {
  },
  props: {
    id: {},
    showTitle: {
      default: true
    },
    isChild: {
      default: false
    }
  },
  data() {
    return {
      notifications : null
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    changeStatus(item, status_codename) {
      if (item.status_codename != status_codename) {
        this.request({
          url: this.endpoint("users/notifications/changeStatus"),
          method: "post",
          loading: false,
          data: {
            id: item.id,
            new_status: status_codename,
          },
          success: (data) => {
            let user = this.user;
            user.unread_notifications_count -= 1;
            this.$store.commit("setUser", user);
            this.$emit("statusChanged");
            this.notify('اعلان خوانده شد', 'success')
            this.getData()
          },
        });
      }
    },
    getData(){
      this.request({
        url: this.endpoint('users/notifications?limit=5&offset=0&search='),
        method: "get",
        success: data => {
          this.notifications = data.results.slice(0,4)
        },
      })
    }
  },


}
</script>

<style scoped lang="scss"></style>

